import * as Sentry from '@sentry/nextjs';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    debug: false,
    tracesSampleRate: 1.0,
    dsn: process.env.SENTRY_DSN,
  });
}
